import requests from '@/utils/request.js'
import { callDynamicAPI } from '@/utils/dynamicApi.js'

// 使用动态API配置替代硬编码URL
// 管理员相关API
export const getAdminListAPI = (data) => callDynamicAPI('systemExtended', 'adminList', data)
export const sendAdminAddAPI = (data) => callDynamicAPI('systemExtended', 'adminAdd', data)
export const sendAdminEditAPI = (data) => callDynamicAPI('systemExtended', 'adminEdit', data)
export const sendAdminEditPsdAPI = (data) => callDynamicAPI('systemExtended', 'adminEditPwd', data)
export const sendAdminDelAPI = (data) => callDynamicAPI('systemExtended', 'adminDelete', data)


// 员工
export const getPersonListAPI = (data) => requests({
  method:'POST',
  url:'/api/user/person/index',
  data
})
export const sendPersonAddAPI = (data) => requests({
  method:'POST',
  url:'/api/user/person/add',
  data
})
export const sendPersonEditAPI = (data) => requests({
  method:'POST',
  url:'/api/user/person/edit',
  data
})
export const sendPersonDelAPI = (data) => requests({
  method:'POST',
  url:'/api/user/person/delete',
  data
})

//客户
export const getCustomerListAPI = (data) => requests({
  method:'POST',
  url:'/api/user/customers/index',
  data
})
export const sendCustomerAddAPI = (data) => requests({
  method:'POST',
  url:'/api/user/customers/add',
  data
})
export const sendCustomerEditAPI = (data) => requests({
  method:'POST',
  url:'/api/user/customers/edit',
  data
})
export const sendCustomerDelAPI = (data) => requests({
  method:'POST',
  url:'/api/user/customers/delete',
  data
})


// 操作日志
export const getLogsListAPI = (data) => requests({
  method:'POST',
  url:'/api/user/log/index',
  data
})

// ==================== 新增API用于动态路由 ====================

/**
 * 获取菜单/规则列表API
 * 用于动态路由生成，返回权限节点数据
 * 后端接口：/api/user/rule/index
 * @param {Object} data 请求参数，通常包含分页等信息
 * @returns {Promise} Promise对象，包含菜单/规则数据
 */
export const getRuleListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/rule/index',
  data
})

/**
 * 获取所有菜单数据（平铺结构）
 * 用于动态路由生成，获取完整的权限节点列表
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含所有菜单节点数据
 */
export const getAllMenuDataAPI = (data = {}) => requests({
  method: 'POST',
  url: '/api/user/rule/index',
  data: { ...data, limit: 1000 } // 获取所有数据，假设1000条足够
})

/**
 * 获取用户有权限的菜单树
 * 根据用户权限返回树形结构的菜单数据
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含树形菜单数据
 */
export const getUserMenuTreeAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/data/menulist', // 根据项目中的路由守卫代码，这个接口可能用于获取菜单
  data
})

// ==================== 其他系统相关API ====================

/**
 * 获取行业列表
 * 用于下拉选择等场景
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含行业数据
 */
export const getIndustryListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/system/industry_index',
  data
})

/**
 * 获取部门列表
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含部门数据
 */
export const getDepartmentListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/system/department_index',
  data
})

/**
 * 获取岗位职称列表
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含岗位职称数据
 */
export const getPositionListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/position/index',
  data
})

/**
 * 获取案件类型列表
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含案件类型数据
 */
export const getCaseTypeListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/casetype/index',
  data
})

/**
 * 获取案源类型列表
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含案源类型数据
 */
export const getCaseSourceListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/sourcetype/index',
  data
})

/**
 * 获取审批流程列表
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含审批流程数据
 */
export const getApprovalProcessListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/flow/index',
  data
})

// ==================== 权限管理相关API ====================

/**
 * 获取权限角色列表
 * 对应接口：api/user/role/index
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象，包含权限角色数据
 */
export const getRoleListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/role/index',
  data
})

/**
 * 新增/编辑功能节点
 * 对应接口：api/user/rule/add
 * @param {Object} data 功能节点数据
 * @returns {Promise} Promise对象
 */
export const saveRoleAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/role/add',
  data
})

/**
 *  edit role
 * @param {Object} data role data
 * @returns {Promise} Promise object
 */
export const editRoleAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/role/edit',
  data
})

/**
 * delete role
 * @param {Object} data delete parameters (usually contains id)
 * @returns {Promise} Promise object
 */
export const deleteRoleAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/role/delete',
  data
})

// ==================== 用户权限管理相关API ====================

/**
 * 获取用户权限列表
 * 对应接口：/api/user/user/permissions
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export const getUserPermissionListAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/user/permissions',
  data
})

/**
 * 分配用户权限
 * 对应接口：/api/user/user/permissions (新增)
 * @param {Object} data 用户权限数据
 * @returns {Promise} Promise对象
 */
export const assignUserPermissionAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/user/permissions',
  data
})

/**
 * 编辑用户权限
 * 对应接口：/api/user/user/permissions (编辑)
 * @param {Object} data 用户权限数据
 * @returns {Promise} Promise对象
 */
export const updateUserPermissionAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/user/permissions',
  data
})

/**
 * 删除用户权限
 * 对应接口：/api/user/user/permissions (删除)
 * @param {Object} data 删除参数（通常包含id）
 * @returns {Promise} Promise对象
 */
export const deleteUserPermissionAPI = (data) => requests({
  method: 'POST',
  url: '/api/user/user/permissions',
  data
})
